import {
  AlphanumericTypeInput,
  AlphanumericTypeProps,
} from '@/components/GeneralInputs/AlphanumericTypeInput';
import {
  PaymentRequestForm,
  TransactionProperty,
} from '@/features/InvoiceReport/Edit/type';
import { memo } from 'react';

type Props<TFieldValues extends PaymentRequestForm> = Omit<
  AlphanumericTypeProps<TFieldValues>,
  'inputProps'
> & {
  property: TransactionProperty;
};

const InnerAlphanumericTypeCell = <TFieldValues extends PaymentRequestForm>({
  control,
  inputId,
  property,
  name,
  rules,
}: Props<TFieldValues>) => {
  return (
    <AlphanumericTypeInput<TFieldValues>
      control={control}
      inputId={inputId}
      name={name}
      placeholder={property.placeholder}
      rules={rules}
    />
  );
};
InnerAlphanumericTypeCell.displayName = 'InnerAlphanumericTypeCell';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const AlphanumericTypeCell = memo(
  InnerAlphanumericTypeCell
) as typeof InnerAlphanumericTypeCell;
AlphanumericTypeCell.displayName = 'AlphanumericTypeCell';
